import { render, staticRenderFns } from "./Memberships.vue?vue&type=template&id=1372d482&scoped=true&"
import script from "./Memberships.vue?vue&type=script&lang=js&"
export * from "./Memberships.vue?vue&type=script&lang=js&"
import style0 from "./Memberships.vue?vue&type=style&index=0&id=1372d482&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1372d482",
  null
  
)

export default component.exports